import { EncodingOperation } from "namirasoft-core";
import { EncryptionOperation } from "namirasoft-site-react";

export class PasswordQuestion
{
    static LIST: string[] = [
        "What was the name of the hospital you were born in?",
        "What was the nickname your family used to call you as a child?",
        "What is the name of the first baby you remember was born?",
        "What is a memorable object or toy you kept for years as a child?",
        "What was your favorite TV show or cartoon as a child?",
        "What is the exact name of your first school?",
        "What is the name of your first teacher?",
        "What was the name of your first pet?",
        "Which number between 1 to 9 is your lucky number?",
        "What was the name of your first childhood friend you remember clearly?",
        "What is the name of a person you considered a hero in your childhood?",
        "What was the name of your first boss?",
    ]

    static EXTRA: string[] = [
        "What was the name of your first childhood friend?",
        "What was your first favorite snack or food as a child?",
        "What is the first item you collected as a hobby?",
        "What was the color of your first car?",
        "What is the first park or playground you visited regularly?",
        "What is the first foreign city you ever visited?",
        "What is the first memorable story or legend you heard as a child?",
        "What is the name of the first city or town you visited on a trip?",
        "Name a person you considered a hero in your childhood.",
        "What was the first concert, movie, or play you attended?",
        "What is your lucky number between 1 to 9?",
        "What is the music instrument you like the most?",
        "What is the sport you like the most?",
        "What is the name of your first girlfriend, boyfriend, partner, or spouse?",
        "What was the first meal you ever cooked by yourself?",
        "What was the first street you lived on as a child?",
        "What is the name of your best friend in high school?",
        "What is the name of your first neighbor?",
        "What was your favorite childhood hideout or secret spot?",
        "What is the title of the first book you finished completely?",
        "What was the brand or model of your first bicycle or motorcycle?",
        "What was your favorite subject in school?",
        "What was your first favorite video game or board game?",
        "What was your first outdoor adventure or trip?",
        "What is the nickname or special name you used for your grandparents?",
        "What was the first item you ever won in a competition or contest?",
        "What was your first favorite family recipe?",
        "What was the first birthday party you attended and remember clearly?",
        "What was the first festival or holiday you remember celebrating?",
        "What was the first skill you learned that made you proud?",
        "What was the first gift you remember giving to someone?",
        "What is the first musical performance you watched or participated in?",
        "What is the name of the first teacher or coach who encouraged you the most?",
        "What was the first memorable joke or prank you played or received?",
        "What was your first piece of art or craft that you were proud of?",
        "What was your first memorable personal accomplishment?",
        "What is the name of a childhood hero or mentor you admired?",
        "What is the first language word or phrase you learned outside your native language?",
        "What was the first app or website you created an account on?",
        "What is the first memorable event or achievement at school?",
    ]
    static SETS: number[][] = [
        [2, 4, 6, 8, 11],
        [2, 5, 6, 9, 11],
        [1, 2, 5, 6, 9],
        [1, 2, 8, 9, 11],
        [3, 4, 6, 7, 11],
        [3, 5, 7, 10, 11],
        [0, 1, 2, 10, 11],
        [0, 4, 6, 7, 8],
        [1, 6, 8, 10, 11],
        [0, 2, 3, 5, 8],
        [0, 2, 7, 10, 11],
        [6, 7, 8, 9, 10],
        [1, 2, 4, 8, 10],
        [4, 5, 6, 9, 10],
        [0, 3, 5, 9, 11],
        [1, 2, 4, 6, 9],
        [0, 1, 4, 9, 10],
        [0, 2, 7, 8, 11],
        [1, 3, 4, 10, 11],
        [0, 2, 5, 6, 11],
        [1, 5, 6, 10, 11],
        [3, 4, 5, 7, 10],
        [3, 7, 9, 10, 11],
        [0, 1, 3, 4, 6],
    ];

    static normalizeAnswer(answer: string): string
    {
        return (answer ?? "").trim().replace(/\s+/g, " ").toLowerCase();
    }

    static async buildAnswerCiphers(answers: string[], master_key: string): Promise<string[]>
    {
        let ciphers: string[] = [];
        for (let i = 0; i < PasswordQuestion.SETS.length; i++)
        {
            let set = PasswordQuestion.SETS[i];
            let answer = set.reduce((acc, index) => acc + PasswordQuestion.normalizeAnswer(answers[index]), "");
            let answer_encoded = EncodingOperation.Base64Encode(answer);
            let answer_ciphered = await EncryptionOperation.AES256GCMEncrypt(answer_encoded, master_key);
            ciphers.push(answer_ciphered);
        }
        return ciphers;
    }
}